import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** メッセージ */
export interface IMessage {
	content: string;
	replacements?: string[];
}

/** メッセージ表示アクションクリエータ */
export const showMessage = actionCreator<{
	messages: IMessage[];
	title: string;
}>('SHOW_MESSAGE');



// WEBPACK FOOTER //
// ./src/actions/message.ts